import { SE, GB, NO, DK, FI, NL } from './countries/mod';
import type { Country } from './countries/mod';

/**
 * ## cortex:national-identity-number
 */
export namespace NiN {
	export interface Implementations {
		SE: SE;
		NO: NO;
		FI: FI;
		DK: DK;
		GB: GB;
		NL: NL;
	}

	export type ImplementationsKeys = keyof Implementations;

	/**
	 * Check if an implementation exists for provided countryCode
	 */
	export function supportsCountryCode(countryCode: string): boolean {
		switch (countryCode) {
			case 'SE':
				return true;
			case 'NO':
				return true;
			case 'FI':
				return true;
			case 'DK':
				return true;
			case 'GB':
				return true;
			case 'NL':
				return true;
			default:
				return false;
		}
	}

	/**
	 * Validates a NiN based on countryCode
	 */
	export function validate(countryCode: keyof Implementations, input: string): boolean {
		const country = produce(countryCode);

		return country.validate(input);
	}

	/**
	 * Tries to normalize different formats
	 */
	export function normalize(countryCode: keyof Implementations, input: string): string {
		const country = produce(countryCode);

		return country.normalize(input);
	}

	/**
	 * Creates a specific Country implementation for given countryCode
	 */
	export function produce(countryCode: keyof Implementations): Country {
		let country: Country;

		switch (countryCode) {
			case 'SE':
				country = new SE();
				break;
			case 'NO':
				country = new NO();
				break;
			case 'FI':
				country = new FI();
				break;
			case 'DK':
				country = new DK();
				break;
			case 'GB':
				country = new GB();
				break;
			case 'NL':
				country = new NL();
				break;
			default:
				throw new Error(`CountryCode "${countryCode}" not implemented`);
		}

		return country;
	}
}
